import React from 'react';

import PackTable from '../packs/view/PackTable';

import Modal from 'CommonComponents/Modal';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function ProcurementPackExpenseEditModal(props) {
    const closeHandler = () => {
        props.closeHandler();
        props.modal.hide();

        // Remove remaining backdrop
        document.querySelector('[modal-backdrop]').remove();

        // Add back at least one backdrop
        const modalBackdrop = document.createElement('div');
        modalBackdrop.setAttribute('modal-backdrop', '');
        modalBackdrop.className = 'tw-bg-gray-900/50 dark:tw-bg-gray-900/80 tw-fixed tw-inset-0 tw-z-40';
        document.body.appendChild(modalBackdrop);
    };

    return (
        <Modal id={props.id} modal={props.modal} parentContainerClasses="!tw-max-w-7xl" modalIndexClass="!tw-z-70">
            <ModalHeader title={$t('Edit Procurement Pack Expense')} close={closeHandler}></ModalHeader>
            <div className="tw-rounded-b">
                {props.showPackTable && (
                    <PackTable
                        editable={true}
                        dataUrl={props.packProcurementUrl}
                        updateUrl={props.updatePackProcurementUrl}
                        cellW="160"
                        cellH="90"
                        dividerW="160"
                        dividerH="100"
                        procurement={props.procurement}
                        successHandler={closeHandler}
                    />
                )}
            </div>
        </Modal>
    );
}
